;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.SendToken = Backbone.Model.extend({
		constructor: function(){
			this.validations = new Model.Validations();
			this.setSchemaValidation();
			Backbone.Model.apply(this, arguments);
		},
		setSchemaValidation: function(){
			this.schema = _.mapObject(this.schema, _.bind(function(value ,key){
				value.validators = this.validations.getValidationItems( value.validators ).length ? this.validations.getValidationItems( value.validators ): value.validators;
				return value;
			}, this));
		},
		url: 'password_recovery/send_token',
		defaults: {
			email: ''
		},
		schema : {
			email:{
				title: 'Email:*',
				editorClass: 'email',
				editorAttrs: {
					placeholder: 'Email:*',
					title: 'Your email will be used as your username when you log in'
				},
				validators:  ['email_validation','email_required']
			}
		}
	});

}(window, APP, Backbone, Marionette, $, _));